/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Pin(props) {
	const group = useRef();
	const { nodes, materials } = useGLTF("models/Logos/pin.glb");
	return (
		<group ref={group} {...props} dispose={null}>
			<mesh
				geometry={nodes.Logo_Pin.geometry}
				material={materials["Material.001"]}
				position={[-0.51, 2.76, -0.05]}
				rotation={[1.53, 0, 0]}
				scale={[53.52, 53.52, 53.52]}
			/>
		</group>
	);
}

useGLTF.preload("/pin.glb");
